import { PropsWithChildren } from 'react';

export const CampaignWrapper = ({ children }: PropsWithChildren) => {
  return <div className="mx-auto w-full max-w-5xl">{children}</div>;
};
